export enum UserIntegrationType {
    CHAT_BOT = 'CHAT_BOT',
}
